import * as angular from 'angular';

import { DowngradedSharedFeatureErrorPagesModule } from '../downgraded-angular/shared/feature-error-pages.module';
import { DowngradedSharedUIModule } from '../downgraded-angular/shared/ui.module';
import { DowngradedCapraModule } from '../downgraded-angular/capra/components.module';
import { DowngradedSharedUtilToastModule } from '../downgraded-angular/shared/util-toast.module';
import { SharedUiAngularjsModule } from '@mode/shared/ui-angularjs';

export const SharedUiModule = angular.module('shared-ui', [
  SharedUiAngularjsModule,
  DowngradedSharedFeatureErrorPagesModule,
  DowngradedSharedUIModule,
  DowngradedCapraModule,
  DowngradedSharedUtilToastModule,
]).name;
